import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import Badge from '../Badge';
import type { BadgePropsWithoutTooltip } from '../../types';

const RecommendedBadge = ({ dataTestId }: BadgePropsWithoutTooltip) => (
  <Badge backgroundColor="blue_900" dataTestId={dataTestId}>
    <I18n k="badges.recommended_badge.text" />
  </Badge>
);

RecommendedBadge.displayName = 'RecommendedBadge';

export default RecommendedBadge;
